import { usePutDeliverObjectId } from '../api/deliver-object-api/deliver-object-api';

export const usePutDeliverObjectUpdate = (options?: any) => {
  return usePutDeliverObjectId(options);
};